<div style="background-color:#fff;">
  <div *ngIf="!containsRawHTML" class="upsellDownsell">
      <header-with-menu [showLogo]="showHeaderLogo" [icon]="icon" [showContent]="showHeaderContent"
      [displayPhone]="displayPhone" [phone]="phone" [phoneIcon]="phoneIcon" [showOnUpsell]="showHeaderOnUpsell"
      [cartQuantity]="originalPurchaseQuantity"></header-with-menu> 

    <!-- INSERT HEADER HERE -->
    <div class="upDownPage paddedforEmpty" no-padding>
      <ng-container *ngFor="let content of pageContents; let i = index;">
          <div *ngIf="content.type == 'html'">
            <div class="content{{ i + 1 }}col {{ content.name }}Content" [innerHTML]="content.html">
            </div>
          </div>

          <ng-container *ngIf="content.type == 'component'">
            <ng-container>
              <ng-container *ngIf="content.componentName == 'progress-bar'">
                 <progress-bar *ngIf="totalProductsSummary" [total]="minForFreeShipping" [current]="totalProductsSummary"
                  [title]="progressBarTitle" [logo]="progressBarLogo" [subTitle]="progressBarSubTitle"
                  [customText]="progressBarCustomText"></progress-bar> 
              </ng-container>

              <ng-container *ngIf="content.componentName == 'upsell-sticky-bar'">
                 <upsell-sticky-bar [brand]="content.options.productBrand || productBrand"
                  [name]="content.options.productName || productName" [image]="productImage"
                  [quantity]="productQuantity" [total]="productYourPrice" [productUnitType]="productUnitType"
                  [addToCartText]="content.options.addToCartText" (eventEmitter)="nextPage($event)"
                   [buttonYesText]="buttonYesText"
                   [buttonNoText]="buttonNoText"
                   [description]="guarantee_01_description"
                  
                  [upsellCtaTextButtonsClass]="guarantee_01_upsellCtaTextButtonsClass"
                  ></upsell-sticky-bar> 
              </ng-container>
              <ng-container *ngIf="content.componentName == 'upsell-steps'">
                  <upsell-steps *ngIf="steps_show" [steps]="steps_items" [stepLabel]="step_label"></upsell-steps> 
              </ng-container>
              <ng-container *ngIf="content.componentName == 'upsell-mbg'">
                  <upsell-mbg *ngIf="steps_show" [steps]="steps_items" [stepLabel]="step_label" [mbgCTA]="mbgCTA" [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText" [productName]="productName" [mbgText]="mbgText" (eventEmitter)="nextPage($event)"></upsell-mbg> 
              </ng-container>
              <ng-container *ngIf="content.componentName == 'upsell-wait'">
                 <upsell-wait *ngIf="wait_show" [isFull]="wait_isFull" [title]="wait_title"
                  [description]="wait_description" [iconText]="wait_text" [iconWait]="iconImgWait">
                </upsell-wait> 
              </ng-container>
              <ng-container *ngSwitchCase="'video-player'">
                <video-player 
                  [videoID]="videoID" 
                  [videoClass]="videoClass"
                  [videoThumbnail]="videoThumbnail"
                  [videoPlayType]="videoPlayType"
                  class="{{ content.class }}"
                >
                </video-player>
              </ng-container>
              <ng-container *ngIf="content.componentName == 'upsell-section'">
                 <upsell-section [content]="content.options"></upsell-section> 
              </ng-container>
              
              <ng-container *ngIf="content.componentName == 'upsell-why'">
                 <upsell-why [upsellWhyContent]="content.options" [upsellWhyImage]="upsellWhyImage"></upsell-why> 
              </ng-container>

              <ng-container *ngIf="content.componentName == 'upsell-faq'">
                 <upsell-faq [upsellFaqContent]="content.options"></upsell-faq> 
              </ng-container>
              <ng-container *ngIf="content.componentName == 'upsell-product-box'">
                
                <upsell-product-box [currency]="currency" [braintreeCurrencyConversion]="braintreeCurrencyConversion" [productBoxTitle]="productBoxTitle"
                  [image]="productImage" [imageAlt]="productTitle"
                  [productBoxSubtitle]="productBoxSubtitle" [regularPrice]="productRegularPrice"
                  [instantSavings]="productInstantSavings" [yourPriceText]="product_box_yourPriceText"
                  [instantSavingsText]="product_box_instantSavingsText" [regularText]="product_box_regularText"
                  [yourPrice]="productYourPrice" [auxImg]="auxImg" [auxImgAlt]="auxImgAlt"
                  [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText" [productBoxCTA]="productBoxCTA"
                  (eventEmitter)="nextPage($event)">
                </upsell-product-box>
              
              </ng-container>
              <ng-container *ngIf="content.componentName == 'upsell-product-box-full'">

                <upsell-product-box-full [currency]="currency" [braintreeCurrencyConversion]="braintreeCurrencyConversion" [title]="product_box_full_title"
                  [image]="productImage" [imageAlt]="productTitle" [additionalImage]="product_box_full_additionalImage"
                  [yourPriceText]="product_box_yourPriceText" [instantSavingsText]="product_box_instantSavingsText"
                  [regularText]="product_box_regularText" [regularPrice]="productRegularPrice"
                  [instantSavings]="productInstantSavings" [yourPrice]="productYourPrice"></upsell-product-box-full>

              </ng-container>
              <ng-container *ngIf="content.componentName == 'upsell-guarantee'">
                 <upsell-guarantee [buttonYesText]="buttonYesText"
                   [buttonNoText]="buttonNoText"
                   [description]="guarantee_01_description"
                   [image]="garantee_01_image"
                  [imageAlt]="garantee_01_imageAlt" [showImage]="garantee_01_showImage"
                  [upsellCtaTextButtonsClass]="guarantee_01_upsellCtaTextButtonsClass"
                  (eventEmitter)="nextPage($event)"></upsell-guarantee> 
              </ng-container>
              <ng-container *ngIf="content.componentName == 'brand-reviews'">
                 <brand-reviews [reviewsTitle]="reviewsTitle" [reviews]="reviews"
                  [perReviewAddOn]="perReviewAddOn"></brand-reviews> 
              </ng-container>
              <ng-container *ngIf="content.componentName == 'upsell-buttons'">
                <upsell-buttons [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText"
                   
                  (onClickYesNoButton)="nextPage($event)">
                </upsell-buttons> 
              </ng-container>
            </ng-container>
          </ng-container>
      </ng-container>
    </div>
    <!-- INSERT FOOTER HERE -->
    
    <upsell-footer [links]="footerLinks" [text]="footerText" [brand]="productBrand"
      [address]="footerAddress"></upsell-footer>
  </div>

  <div *ngIf="containsRawHTML" class="rawHTML"></div>
</div>